export const config = {
  axios: {
    baseURL: "https://microexpressionstrainingvideos.com/",
  },
  awsS3CDN: "https://microexpressionscf.s3.amazonaws.com/",
};
